import React, { useEffect } from 'react';
import { useParams, Link, Navigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import { ArrowLeftIcon } from 'lucide-react';
import { getModuleById, getModuleByCourseAndId } from '../data/courseData';
import { LessonCard } from '../components/LessonCard';
import { PointsCard } from '../components/PointsCard';
export function Module() {
  const {
    moduleId,
    courseId
  } = useParams<{
    moduleId: string;
    courseId?: string;
  }>();
  // Scroll to top when module changes - now instant instead of smooth
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [moduleId, courseId]);
  // Try to get module from course structure first, then fall back to legacy
  const module = courseId && moduleId ? getModuleByCourseAndId(courseId, moduleId) : moduleId ? getModuleById(moduleId) : undefined;
  if (!module) {
    return <Navigate to="/cursuri" replace data-id="element-8560" />;
  }
  // Fixed: Navigate back to the specific course page when courseId exists, otherwise go to courses overview
  const backLink = courseId ? `/curs/${courseId}` : '/cursuri';
  return <div className="w-full min-h-screen bg-[#F1F1F1]" data-id="element-8561">
      <div className="bg-gradient-to-br from-[#132C53] to-[#1e4278] text-white py-16" data-id="element-8562">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-8563">
          <Link to={backLink} className="inline-flex items-center space-x-2 text-gray-300 hover:text-white mb-6 transition-colors" data-id="element-8564">
            <ArrowLeftIcon className="w-4 h-4" data-id="element-8565" />
            <span data-id="element-8566">Înapoi la training</span>
          </Link>
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.5
        }} data-id="element-8567">
            <h1 className="text-4xl md:text-5xl font-bold mb-4" data-id="element-8568">
              {module.title}
            </h1>
            <p className="text-xl text-gray-300 mb-6" data-id="element-8569">{module.description}</p>
            <div className="flex items-center space-x-4 text-sm" data-id="element-8570">
              <span className="bg-[#357BEB] bg-opacity-30 px-4 py-2 rounded-lg" data-id="element-8571">
                {module.lessons.length} lecții
              </span>
            </div>
          </motion.div>
        </div>
      </div>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8" data-id="element-8572">
        <div className="mb-8" data-id="element-8573">
          <PointsCard compact data-id="element-8574" />
        </div>
        <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} transition={{
        duration: 0.5,
        delay: 0.2
      }} data-id="element-8575">
          <h2 className="text-2xl font-bold text-[#132C53] mb-8" data-id="element-8576">
            Lecțiile modulului
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-8577">
            {module.lessons.map((lesson, index) => <LessonCard key={lesson.id} lesson={lesson} moduleId={module.id} courseId={courseId} index={index} data-id="element-8578" />)}
          </div>
        </motion.div>
      </div>
    </div>;
}